import React from "react";

const QuotationFooter = ({ quotation }) => {
  const organization = quotation?.organization || {};

  return (
    <footer className="quotation-footer">
      <div className="quotation-footer-inner">
        <div>
          <h3>{organization.name || "PristinePV"}</h3>

          <p>
            {organization.address || ""}
            <br />

            {organization.city || ""}

            {organization.city &&
            organization.postalCode
              ? ", "
              : ""}

            {organization.postalCode || ""}
          </p>
        </div>

        <div>
          <p>
            <strong>Phone:</strong>{" "}
            {organization.phone || "-"}
          </p>

          <p>
            <strong>Email:</strong>{" "}
            {organization.email || "-"}
          </p>
        </div>
      </div>

      <div className="quotation-footer-bottom">
        © {new Date().getFullYear()}{" "}
        {organization.name || "PristinePV"}. All rights
        reserved.
      </div>
    </footer>
  );
};

export default QuotationFooter;